// import { useCallback } from "react"
import { InteractiveMeshElement } from "../Components/BakedMeshComponents"
import { useStore } from "../State/Store"
import { returnsFloor } from "../Utils/Helpers"
import {
  useApartmentBedsByPlotNumber,
  useApartmentStatusByPlotNumber,
  useBlocks
} from "../Utils/hooks"
import { useAvailableApartments } from "../Utils/hooks"
// import { FloatingNumber } from "./InteractiveBuilding.style";

function InteractiveBuilding({ buildingID, clickedMesh }) {
  const apartmentBedsByPlotNumber = useApartmentBedsByPlotNumber()
  const apartmentStatusByPlotNumber = useApartmentStatusByPlotNumber()
  const pathToGLTF = `interactiveBuildings/${buildingID}/${buildingID}`

  const blocks = useBlocks({ pathToGLTF })
  const blocksArr = Object.values(blocks)

  return (
    <>
      {blocksArr.map((b, i) => (
        <InteractiveBlock
          apartmentBedsByPlotNumber={apartmentBedsByPlotNumber}
          apartmentStatusByPlotNumber={apartmentStatusByPlotNumber}
          key={i}
          id={i}
          blocks={b}
          buildingID={buildingID}
          clickedMesh={clickedMesh}
        />
      ))}
    </>
  )
}

function InteractiveBlock({
  blocks,
  id,
  buildingID,
  clickedMesh,
  apartmentBedsByPlotNumber,
  apartmentStatusByPlotNumber
}) {
  // console.log(position);
  //* Store stuff

  let activeBlock = useStore(state => state.activeBlock)
  const activeFloor = useStore(state => state.activeFloor)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)

  //* Find center of each block to anchor Html display no. apartments that it contains
  // const reducer = (accumulator, currentValue) => accumulator + currentValue
  let tempArr = []
  blocks.map(b => {
    if (b.name.split("-")[3].split("_")[2] !== "AA") {
      tempArr.push(b.name)
    }
    return null
  })

  //* Create a texture path based on BUILDING IDs
  // const texturePath = `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/${buildingID}/textures/`

  const availableApartments = useAvailableApartments()

  const thisID = blocks[id].name.split("-")[3].split("_")[0]

  function isActive(id) {
    if (id === activeBlock) {
      return true
    } else return false
  }

  let contains = []
  availableApartments.map((_, i) =>
    availableApartments[i].PlotNumberPlanning.split(".")[0] === thisID
      ? contains.push("t")
      : null
  )
  const floorArr = new Array(activeFloor)

  for (let i = 0; i < activeFloor; i++) {
    floorArr.push(i)
  }

  return (
    <group>
      {blocks.map((b, i) =>
        floorArr.includes(parseInt(returnsFloor(b.name) - 1)) ||
        b.name.split("-")[3].split("_")[0] !== activeBlock ||
        apartmentFinderActive !== true ? (
          // <group>
          <InteractiveMeshElement
            apartmentBedsByPlotNumber={apartmentBedsByPlotNumber}
            apartmentStatusByPlotNumber={apartmentStatusByPlotNumber}
            apartmentFinderActive={apartmentFinderActive}
            name={b.name}
            key={i}
            floor={parseInt(b.name.split("-")[2])}
            mesh={b.geometry}
            // texturePath={texturePath + b.name.split("-")[1]}
            blockID={b.name.split("-")[3].split("_")[0]}
            blockActive={isActive(b.name.split("-")[3].split("_")[0])}
            clickedMesh={clickedMesh}
          />
        ) : null
      )}
    </group>
  )
}

export default InteractiveBuilding
